import styled from "@emotion/styled";
import React from "react";

type Props = { badge?: number; icon: React.ReactNode; onClick: () => void };

export default function NavbarActionButton(props: Props) {
  return (
    <Root onClick={props.onClick}>
      {props.icon}
      {props.badge !== undefined && props.badge > 0 && <Badge>{props.badge}</Badge>}
    </Root>
  );
}

const Root = styled.div`
  position: relative;
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Badge = styled.div`
  background-color: var(--tw-red-500);
  position: absolute;
  font-size: 12px;
  font-weight: 600;
  color: white;
  line-height: 12px;
  padding: 2px 4px;
  border-radius: 32px;
  min-width: 20px;
  box-sizing: border-box;
  transform: translate(25%, -40%);
  border: 2px solid var(--tw-slate-50);
`;
